import {adicRestApi, adicRestApiSearchUrl} from "@common/services/restapi";

export const getSearchInfo = async (keyword) => {
  const url = adicRestApiSearchUrl
    .segment("/")
    .query({
      keyword: keyword,
    })
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getSearchDetailInfo = async (category, keyword, pageNumber, pageSize) => {
  const url = adicRestApiSearchUrl
    .segment("/:category/list")
    .query({
      keyword: keyword,
      pageNumber: pageNumber,
      pageSize: pageSize
    })
    .param({ category })
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};
